export default __webpack_public_path__ + "static/media/PENT.a557ce3a.svg";